<div class="ml-72 mr-72 mt-24">
  <app-breadcrumb class="mt-16" [items]="breadcrumbItems"></app-breadcrumb>

  <div class="flex flex-row justify-between">
    <div class="flex flex-row flex-auto header-section p-24 mt--20" [ngClass]="isActivityInProgress? 'remove-border' : ''">
      <div class="flex flex-row items-center">
        <mat-icon svgIcon="arrow_back" class="icon cursor-pointer mt-0 mr-24" (click)="goToInstances()"></mat-icon>
      </div>
      <div class="flex flex-col flex-auto justify-between pr-20">
        <div class="flex flex-row justify-between mb-12">
          <div *ngIf="data?.name; else headerLoader" class="mat-subtitle-1 fw-600 mb-0">{{ data?.name }}</div>

          <div class="flex flex-row justify-center items-center">
            <mat-spinner *ngIf="loaderStatus.includes(data?.status)" diameter="20"
                         class="mr-12"
                         color="primary"
                         mode="indeterminate">
            </mat-spinner>
            <div class="flex flex-row justify-center items-center pt-4 pb-4 pl-8 pr-8" [ngClass]="data?.status === DeployStatus.TERMINATION_FAILED || data?.status === DeployStatus.CONFIGURATION_FAILED  || data?.status === DeployStatus.TEST_FAILED ? 'failed': data?.status">
              <mat-icon *ngIf="statusIcons[data?.status]" [svgIcon]="statusIcons[data?.status]" class="icon-md p-2 mr-8"></mat-icon>
              <div>{{data?.status | titlecase}}</div>
            </div>
          </div>
        </div>
        <div class="flex justify-between">
          <div class="flex flex-row sub-header items-center"> 
            <div class="flex flex-row justify-center items-center vertical-indicator pr-16 fs-14">
              <span>{{'INSTANCE_DETAILS.SERVICE_DEFINITION' | transloco}}: {{blueprint?.name ? blueprint?.name : '-'}}</span>
            </div>
            <div class="flex flex-row justify-center items-center vertical-indicator ml-16 pr-16 fs-14">
              <mat-icon svgIcon="inventory_2" class="icon-sm mr-6"></mat-icon>
              <span>{{('INSTANCE_DETAILS.RELEASE_PACKAGE' | transloco) + ':-' }}</span>
            </div>
            <div class="flex flex-row justify-center items-center ml-16 pr-16 fs-14">
              <mat-icon svgIcon="token" class="icon-sm mr-6"></mat-icon>
              <span class="mr-10">
                {{('BLUEPRINT_SUMMARY.RELEASE' | transloco) + ': ' +
                (data?.status === DeployStatus.NOT_DEPLOYED  ? '-' : latestReleaseVersion ? latestReleaseVersion : '-') }}
              </span>
              <div *ngIf="isAMR" class="flex flex-row justify-center items-center vertical-dash pl-10">
                {{('BLUEPRINT_SUMMARY.AMR' | transloco)}}
              </div>
            </div>  
            <!-- <div class="flex flex-row pl-16 fs-14">
              <mat-icon svgIcon="open_in_new" class="icon-sm mt-2 mr-4"></mat-icon>
              <div>
                <a class="view-release-internal-link cursor-pointer pb-0"
                *ngIf="viewReleaseNotes; else releaseNotesDisabled" [href]="viewReleaseNotes"
                target="_blank">{{'BLUEPRINT_SUMMARY.RELEASE_NOTES' | transloco}}</a>
              <ng-template #releaseNotesDisabled>
                <div class="view-release-internal-link disabled-link cursor-default">
                  {{'BLUEPRINT_SUMMARY.RELEASE_NOTES' | transloco}}</div>
              </ng-template>
              </div>
            </div>   -->
            <ng-template #loader>
              <div class="pl-6 skeleton-loader pr-16">
                <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
              </div>
            </ng-template>
            <ng-template #headerLoader>
              <div class="pl-6 skeleton-loader-header">
                <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
              </div>
            </ng-template>
          </div>
          <div class="flex flex-row justify-end items-end">
            <span class="fw-400 fs-14 modified-by-color">{{'INSTANCE_DETAILS.MODIFIED_BY' | transloco}}:</span><div>&nbsp;</div><span class="fw-500 fs-16">{{data?.modifiedBy ? data?.modifiedBy : '-'}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="ml-48 mr-48">
  <app-instance-details *ngIf="data && solution"
    [data]="data"
    [solution]="solution"
    [isLoading]="isLoading"
    [instanceDetailsKeys]="instanceDetailsKeys"
    [getBlueprints]="blueprint"
  ></app-instance-details>
  <mat-card *ngIf="isLoading" class="spinner flex flex-row justify-center items-center">
    <mat-spinner diameter="24"
      color="primary"
      mode="indeterminate">
    </mat-spinner>
  </mat-card>
</div>



